"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewRegistryController = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const calcViewIsDirty_1 = __importDefault(require("@opsbase/lib-data-view/helpers/calcViewIsDirty"));
const cloneView_1 = __importDefault(require("@opsbase/lib-data-view/helpers/cloneView"));
const ViewLibrary_1 = __importDefault(require("@opsbase/lib-data-view/ViewLibrary"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const formQuestionsToFormWithTree_1 = __importDefault(require("@opsbase/lib-form/convert/formQuestionsToFormWithTree"));
const getViewFieldsFromQuestions_1 = require("@opsbase/lib-form/helpers/getViewFieldsFromQuestions");
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const useSelfLanguage_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelfLanguage"));
const usePopDefinitions_1 = __importDefault(require("@opsbase/react-gql-hooks/popdefinition/usePopDefinitions"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const react_1 = __importStar(require("react"));
const calcChartsForView_1 = __importDefault(require("../helpers/calcChartsForView"));
const ViewRegistryContext_1 = __importDefault(require("../useViewRegistry/ViewRegistryContext"));
const ViewRegistryActionsContext_1 = __importDefault(require("../useViewRegistryActions/ViewRegistryActionsContext"));
function ViewRegistryController({ children }) {
    const { forceUpdate, tick, acknowledgeUpdate } = (0, useForceUpdate_1.default)();
    const { app } = (0, useAppState_1.default)();
    const viewRegistry = (0, react_1.useRef)();
    const { language } = (0, useSelfLanguage_1.default)();
    const isAlt = (0, react_1.useMemo)(() => language && language !== Language_1.default.ENGLISH, [language]);
    const [opDefinitionIds, setOpDefinitionIds] = (0, react_1.useState)();
    const updatingViewIds = (0, react_1.useRef)();
    const { data: popDefinitions, loading: popDefLoading } = (0, usePopDefinitions_1.default)({
        variables: { opDefinition: opDefinitionIds, latest: ['TRUE'] },
        skip: !(opDefinitionIds === null || opDefinitionIds === void 0 ? void 0 : opDefinitionIds.length),
    });
    const initViewRegistry = (0, react_1.useCallback)(() => {
        viewRegistry.current = (0, flatten_1.default)(Object.values(ViewLibrary_1.default).filter(s => !!s))
            .filter(v => { var _a; return ((_a = v === null || v === void 0 ? void 0 : v.apps) === null || _a === void 0 ? void 0 : _a.indexOf(app)) >= 0; })
            .map(v => (Object.assign(Object.assign({}, v), { isSystem: true })))
            .reduce((p, c) => (Object.assign(Object.assign({}, p), { [c.id]: c })), {});
        forceUpdate();
    }, [app, forceUpdate]);
    // if we really have popdefs, then attempt to load the stuff
    const reinitedViewsForLanguageSupport = (0, react_1.useRef)(false);
    const hasOpDefIds = (opDefinitionIds === null || opDefinitionIds === void 0 ? void 0 : opDefinitionIds.length) > 0;
    (0, react_1.useEffect)(() => {
        var _a;
        if (!reinitedViewsForLanguageSupport.current &&
            hasOpDefIds &&
            !popDefLoading &&
            (popDefinitions === null || popDefinitions === void 0 ? void 0 : popDefinitions.length)) {
            reinitedViewsForLanguageSupport.current = true;
            let didUpdate = false;
            for (const viewId of updatingViewIds.current) {
                const view = viewRegistry.current[viewId];
                if (popDefinitions === null || popDefinitions === void 0 ? void 0 : popDefinitions.length) {
                    const opDefinitionFilters = (_a = view.filters) === null || _a === void 0 ? void 0 : _a.filter(z => z.queryFieldKey === QueryFieldKey_1.default.OPDEFINITION);
                    if (opDefinitionFilters === null || opDefinitionFilters === void 0 ? void 0 : opDefinitionFilters.length) {
                        const opDefId = opDefinitionFilters[0].id;
                        if (opDefId) {
                            const popDefinition = popDefinitions.find(z => z.opDefinitionId === opDefId);
                            if (popDefinition) {
                                const form = (0, formQuestionsToFormWithTree_1.default)(popDefinition.form);
                                const fields = view.fields;
                                for (const field of fields) {
                                    if (field.key === ViewFieldKey_1.default.QUESTIONANSWER) {
                                        const q = form.questions[field.questionNodeId];
                                        const calculatedFieldValues = (0, getViewFieldsFromQuestions_1.calcLabelsFor)(q, form, language);
                                        field.label = calculatedFieldValues.label;
                                        field.aggLabel = calculatedFieldValues.aggLabel;
                                        field.aggFlag = calculatedFieldValues.aggFlag;
                                    }
                                }
                                didUpdate = true;
                            }
                        }
                    }
                }
            }
            if (didUpdate) {
                forceUpdate();
            }
        }
    }, [forceUpdate, language, hasOpDefIds, popDefLoading, popDefinitions]);
    // when we have the views loaded, check for the ones with op type
    // and do the shenanigans for loading a different language, if required
    (0, react_1.useEffect)(() => {
        var _a;
        if (isAlt) {
            acknowledgeUpdate(tick);
            if (viewRegistry.current) {
                const values = Object.values(viewRegistry.current);
                const viewOpDefinitionIds = [];
                const viewIds = [];
                for (const view of values) {
                    if (view.type === DataType_1.default.OP) {
                        const opDefinitionFilters = (_a = view.filters) === null || _a === void 0 ? void 0 : _a.filter(z => z.queryFieldKey === QueryFieldKey_1.default.OPDEFINITION);
                        if (opDefinitionFilters === null || opDefinitionFilters === void 0 ? void 0 : opDefinitionFilters.length) {
                            viewOpDefinitionIds.push(opDefinitionFilters[0].id);
                            viewIds.push(view.id);
                        }
                    }
                }
                updatingViewIds.current = viewIds;
                setOpDefinitionIds(viewOpDefinitionIds);
            }
        }
    }, [acknowledgeUpdate, isAlt, tick]);
    const clearNonSystemViews = (0, react_1.useCallback)(() => {
        Object.keys(viewRegistry.current).forEach(viewId => {
            const view = viewRegistry.current[viewId];
            if (!view.isSystem)
                delete viewRegistry.current[viewId];
        });
    }, []);
    const setView = (0, react_1.useCallback)((view, recalcCharts = true, recalcDirty = true) => {
        if (recalcDirty)
            (0, calcViewIsDirty_1.default)(view);
        if (recalcCharts)
            (0, calcChartsForView_1.default)(view);
        viewRegistry.current = Object.assign(Object.assign({}, viewRegistry.current), { [view.id]: view });
        forceUpdate();
    }, [forceUpdate]);
    const getView = (0, react_1.useCallback)((viewId) => {
        return viewRegistry.current[viewId];
    }, []);
    const cloneView = (0, react_1.useCallback)((viewId) => {
        const origView = viewRegistry.current[viewId];
        const newView = (0, cloneView_1.default)(origView);
        newView.isDirty = true;
        newView.cleanLmss = origView.cleanLmss || origView;
        return newView;
    }, []);
    const deleteView = (0, react_1.useCallback)((viewId) => {
        if (!viewRegistry.current[viewId])
            return;
        const newView = Object.assign({}, viewRegistry.current);
        delete newView[viewId];
        viewRegistry.current = newView;
        forceUpdate();
    }, [forceUpdate]);
    const putView = (0, react_1.useCallback)((view, doNotOverride = false) => {
        if (!view)
            return;
        const existing = viewRegistry.current[view.id];
        // Do we want to allow it to be reset back to its original state?
        if (doNotOverride && !!existing) {
            view.cleanLmss = existing.cleanLmss || existing;
            setView(view);
        }
        else {
            setView(view, true, false);
        }
    }, [setView]);
    (0, react_1.useEffect)(() => {
        if (!!viewRegistry.current)
            return;
        initViewRegistry();
    }, [initViewRegistry]);
    const ctx = (0, react_1.useMemo)(() => {
        acknowledgeUpdate(tick);
        return viewRegistry.current;
    }, [acknowledgeUpdate, tick]);
    const actionCtx = (0, react_1.useMemo)(() => ({
        clearNonSystemViews,
        getView,
        setView,
        putView,
        deleteView,
        cloneView,
    }), [clearNonSystemViews, cloneView, deleteView, getView, putView, setView]);
    return (react_1.default.createElement(ViewRegistryContext_1.default.Provider, { value: ctx },
        react_1.default.createElement(ViewRegistryActionsContext_1.default.Provider, { value: actionCtx }, children)));
}
exports.ViewRegistryController = ViewRegistryController;
exports.default = ViewRegistryController;
